export default __webpack_public_path__ + "static/media/confetti.da67f84f.png";